module.exports = __webpack_public_path__ + "img/img-42.e23c6700.png";